/** @module Domain */

// local-test.【开大】部署环境
const DOMAIN_LOCAL = {
  key: 'DOMAIN_LOCAL',
  // ajax接口域名
  api:  `https://${process.env.DEV_DOMAIN}/`,
  // websocket域名
  ws: `https://wss-${process.env.DEV_DOMAIN}/`,
};

// local-test.
const DOMAIN_LOCAL_V2 = {
  key: 'DOMAIN_LOCAL_V2',
  // ajax接口域名
  api: 'https://admin.shou.org.cn',
  // websocket域名
  ws: 'https://wss-admin.shou.org.cn',
};

// local-test.
const DOMAIN_LOCAL_V3 = {
  key: 'DOMAIN_LOCAL_V2',
  // ajax接口域名
  api: 'https://oaim.kefutcs3.qidian.qq.com',
  // websocket域名
  ws: 'https://wss-oaim.kefutcs3.qidian.qq.com'
};

// oa
const DOMAIN_OA = {
  key: 'DOMAIN_OA',
  // ajax接口域名
  api: 'https://testgateway.qidian.qq.com',
  // websocket域名
  ws: 'https://testwss.qidian.qq.com', // 'https://wss-oaimprivate.qidian.qq.com', // 'https://testwss.qidian.qq.com',
  consolecgi: 'https://oaconsolecgi.qidian.qq.com', // 'https://consolecgi.qidian.qq.com', // 'https://oaconsolecgi.qidian.qq.com',
  zhiwen:'https://oazhiwen.qidian.qq.com'
};

// 私有化WSS path
const PRIVATE_WSS =
  typeof location != 'undefined' ? `https://wss-${location.host}` : '';

const PRIVATE_GATEWAY = typeof location != 'undefined' ? `https://${location.host.replace(/^[^.]+/, 'gateway')}` : '';
// 私有化-oa
const DOMAIN_OA_PRIVATE = {
  key: 'DOMAIN_OA_PRIVATE',
  // ajax接口域名
  api: PRIVATE_GATEWAY,
  // websocket域名
  ws: PRIVATE_WSS,
  zhiwen: '',
  consolecgi: '',
};

// 线上
const DOMAIN_OL = {
  key: 'DOMAIN_OL',
  api: 'https://gateway.qidian.qq.com',
  ws: 'https://c.mango.qidian.qq.com', // C侧专用域名
  consolecgi: 'https://consolecgi.qidian.qq.com',
  zhiwen:'https://oazhiwen.qidian.qq.com'

};

// 私有化-线上-其实没用
const DOMAIN_OL_PRIVATE = DOMAIN_OA_PRIVATE;
DOMAIN_OL_PRIVATE.key = 'DOMAIN_OL_PRIVATE';

// local, mock 模拟数据用
const DOMAIN_LOCAL_MOCK = {
  key: 'DOMAIN_LOCAL_MOCK',
  // ajax接口域名
  api: '',
  // websocket域名
  ws: '',
};

// local, 本地代理使用
const DOMAIN_LOCAL_PROXY = {
  key: 'DOMAIN_OA',
  // ajax接口域名
  api: 'https://oaim.kefutcs2.qidian.qq.com',
  // websocket域名
  ws: 'https://testwss.qidian.qq.com', // 'https://wss-oaimprivate.qidian.qq.com', // 'https://testwss.qidian.qq.com',
};

// eslint-disable-next-line import/no-mutable-exports
let IM_DOMAIN;
if (process.env.BRANCH_ENV === 'local_mock') {
  IM_DOMAIN = DOMAIN_LOCAL_MOCK;
} else if (process.env.BRANCH_ENV === 'local_proxy') {
  IM_DOMAIN = DOMAIN_LOCAL_PROXY;
} else if (process.env.BRANCH_ENV === 'dev') {
  // 本地测试 - 私有化1期
  IM_DOMAIN = DOMAIN_LOCAL;
} else if (process.env.BRANCH_ENV === 'dev2') {
  // 本地测试 -私有化二期
  IM_DOMAIN = DOMAIN_LOCAL_V2;
} else if (process.env.BRANCH_ENV === 'dev3') {
  // 本地测试 -私有化二期
  IM_DOMAIN = DOMAIN_LOCAL_V3;
} else if (process.env.BRANCH_ENV === 'oaprivate') {
  // 私有化-oa
  IM_DOMAIN = DOMAIN_OA_PRIVATE;
} else if (process.env.BRANCH_ENV === 'oa') {
  // oa
  IM_DOMAIN = DOMAIN_OA;
} else if (process.env.BRANCH_ENV === 'private') {
  // 私有化-正式
  IM_DOMAIN = DOMAIN_OL_PRIVATE;
} else {
  // 正式
  IM_DOMAIN = DOMAIN_OL;
}

/** SDK内部使用域名配置 */
export interface SDKDomain {
  /** @internal key标记。 */
  key: string,
  /** api接口的域名 */
  api: string,
  /** websocket的域名 */
  ws: string,
}

/**
 * 内置域名管理
 * 整体逻辑：
 * 1. 先根据编译条件查看是否是【本地调试/私有化/oa/正式】环境，然后获得一个默认值。
 * 2. 如果是对外SDK，且调用了【setSDKDomainEnv】，则根据传入的 oa/ol 值来确定使用oa域名还是线上域名。
 * 3. 或者直接调用【setSDKDomain】来更新内部域名。
 * @example
 * ```ts
 * const { Domain } = window.QD_WEBIM;
 * // import { Domain } from './imsdk';
 * ```
 */
export default {
  SDK_DOMAIN_ENV: '',
  // 外部用户设置的域名
  CUSTOMER_DOMAIN: <any>null,
  /**
   * 设置域名环境。默认情况下，根据编译条件生成DOMAIN。通过此方法修改env后，会覆盖掉原先条件编译生成的DOMAIN。
   * 仅对SDK的两组域名生效：ol=线上环境, oa=测试环境。
   * 请配合 getSDKDomain 一同使用。
   * @param env 环境值。ol=线上环境, oa=测试环境。
   * @example
   * ```ts
   * Domain.setSDKDomainEnv('oa');
   * ```
   */
  setSDKDomainEnv(env: string = 'ol') {
    this.SDK_DOMAIN_ENV = env;
  },
  /**
   * 获得SDK的内置域名。
   * @param env 域名环境。如果设置了，则会覆盖掉setSDKDomainEnv中设置的值。
   * @returns 返回SDK中使用的域名信息
   */
  getSDKDomain(env?: string): SDKDomain {
    // 如果用户外部定义了域名，就使用外部定义的
    if (this.CUSTOMER_DOMAIN) {
      return this.CUSTOMER_DOMAIN;
    }

    // 当非SDK模式时，直接之前条件编译的域名
    if (!process.env.IS_SDK) {
      return IM_DOMAIN;
    }

    // SDK的域名处理
    env && (this.SDK_DOMAIN_ENV = env);
    let domain;
    //修改SDK的域名环境，oa 或 ol
    if (this.SDK_DOMAIN_ENV === 'oa') {
      domain = DOMAIN_OA;
    } else {
      domain = DOMAIN_OL;
    }
    return domain;
  },

  /**
   * 直接从外部设置api域名和ws域名，忽略内部配置。
   * @param domain 要设置的域名配置
   * @example
   * ```ts
   * Domain.setSDKDomain({ api: 'https://test.com/api', ws: 'wss://test.com/ws' });
   * ```
   */
   setSDKDomain(domain: SDKDomain) {
    if (!domain.key) {
      Object.assign(domain, {
        key: 'CUSTOMER',
      });
    }

    this.CUSTOMER_DOMAIN = domain;
  },
};
